export const FETCH_ONBOARDING_CONFIG_REQUEST = 'FETCH_ONBOARDING_CONFIG_REQUEST';
export const FETCH_ONBOARDING_CONFIG_SUCCESS = 'FETCH_ONBOARDING_CONFIG_SUCCESS';
export const FETCH_ONBOARDING_CONFIG_FAILURE = 'FETCH_ONBOARDING_CONFIG_FAILURE';

export const UPDATE_ONBOARDING_CONFIG_REQUEST = 'UPDATE_ONBOARDING_CONFIG_REQUEST';
export const UPDATE_ONBOARDING_CONFIG_SUCCESS = 'UPDATE_ONBOARDING_CONFIG_SUCCESS';
export const UPDATE_ONBOARDING_CONFIG_FAILURE = 'UPDATE_ONBOARDING_CONFIG_FAILURE';

export const fetchOnboardingConfig = () => ({
    type: FETCH_ONBOARDING_CONFIG_REQUEST
});

export const updateOnboardingConfig = (config) => ({
    type: UPDATE_ONBOARDING_CONFIG_REQUEST,
    payload: config
});
